<template>
    <div class="my-10">
        <h1 v-if="!isTag" class="mb-7 text-xl">{{ $t('page.searchResults') }}: <span class="font-semibold">{{ this.searchQuery }}</span></h1>
        <h1 v-else class="mb-7 text-xl">{{ $t('page.tags') }}: <span class="bg-[#D9D9D9] font-light text-base text-main-color py-2 px-3 rounded">#{{ this.searchQuery }}</span></h1>
        <div class="grid grid-cols-4 gap-4 max-lg:grid-cols-3 max-md:grid-cols-2">

            <template v-if="news.length > 0">
                <router-link v-for="item in news" :key="item?.id"
                    :to="{ name: 'newsDetail', params: { id: item?.id } }">
                    <NewsCard :detail="item">
                    </NewsCard>
                </router-link>
            </template>
            <div v-show="news.length === 0 && loading === false">
                <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
            </div>

        </div>
        <div v-show="loading === true" class="flex justify-center mt-10" role="status">
            <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
            </IconSpinner>

            <span class="sr-only">Loading...</span>
        </div>
    </div>

</template>

<script>
import NewsCard from '@cmp/media/NewsCard.vue'

import IconSpinner from '@icons/IconSpinner.vue';
import api from '@/api';
export default {
    name: 'news',
    components: {
        NewsCard,
        IconSpinner
    },
    watch: {
        '$route.query.searchQuery': {
            //   immediate: true,
            async handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.currentCategory = newValue
                    this.news = []
                    await this.getNews()
                }

            },
        },

    },
    data() {
        return {
            loading: false,
            news: [],
            searchQuery: null,
            isTag: false,
            page: 1,
            count: 0,
            next: null
        }
    },
    methods: {
        infiniteScroll() {
            let scrollTop = document.documentElement.scrollTop
            let scrollHeight = document.documentElement.scrollHeight
            let clientHeight = document.documentElement.clientHeight
            if (scrollTop + clientHeight >= scrollHeight - 650) {
                if (this.next !== null && this.loading === false) {
                    this.page += 1
                    this.getNews()
                }
            }
        },
        async getNews() {
            this.loading = true
            try {
                const response = await api.get('posts/announcements/', { params: { search: this.searchQuery, page: this.page, location: this.getLocation.id } })
                const results = response.data.results
                results.forEach(element => {
                    this.news.push(element)
                });
                this.count = response.data.count
                this.next = response.data.next
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },
    },
    computed: {
        getLocation(){
            return JSON.parse(localStorage.getItem('selectedLocation')) || 1
        }
    },
    mounted() {
        window.addEventListener("scroll", this.infiniteScroll)
    },
    unmounted() {
        window.removeEventListener("scroll", this.infiniteScroll)
    },
    async created() {
        this.searchQuery = this.$route.query.searchQuery
        this.isTag = this.$route.query.isTag
        await this.getNews()

    }
}

</script>

<style scoped></style>
